import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { colors } from '../../styles';

const styles = css`
  padding: 0;
  margin: 0px;
  width:100%;
  .FHCarousel_wrapper{
    width: 100%;
    margin:auto;
    display: flex;
    justify-content: center;
  }
  .Carousel_thumbnailsWrapper {
    display: none;
    position: relative;
    @media (min-width: 992px) {
      display: block;
      margin: 0;
      overflow: hidden;
    }
  }
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    white-space: nowrap;

  }
  .Carousel_thumbnailItem {
    display: inline-block;
    white-space: nowrap;
    position: relative;
    margin: 0;
    width: 25%;
    height: 132px;
    background-color: transparent;
    &:nth-child(4) {
      .Carousel_additionalOverlay {
        display: block;
      }
    }
  }
  .Carousel_thumbnailItem:after {
    display: none;
    content: " ";
    top: auto;
    bottom: 0;
    right: 0;
    left: 0;
    height: 8px;
    border-top: 1px solid #FFFFFF;
    position: absolute;
    background-color: ${colors.color7};
    z-index: 1;
    pointer-events: none;
  }
  .Carousel_thumbnailItem-active:after {
    display: block;
  }
  img {
    width: 100%;
    height: 100%;
  }
  .Carousel_additionalOverlay {
    display: none;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color:${colors.color1};
    opacity:.85;
  }
  .AdditionalOverlay_text{
    font-size: 24px;
    line-height: 31px;
    font-weight: bold;
    color: #FFF;
    margin: 0 auto;
    position: absolute;
    top: 42.5%;
    left: 40%;
  }
  .Carousel_videoOverlay {
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color:${colors.color2};
    opacity:.5;
    background-image: url('/images/icon-video-white.svg');
    background-position: center center;
    background-size: 32px 32px;
    background-repeat: no-repeat;
  }
  .Carousel_tourOverlay {
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color:${colors.color2};
    opacity:.85;
    height:100%;
    background-image: url('/images/icon-tour-white.svg');
    background-position: center center;
    background-size: auto 34px;
    background-repeat: no-repeat;
  }

   .Carousel_image {
      position: relative;
      padding-top:30px;
      padding-bottom: 30px;
      height:auto;

    .Carousel_imageElement {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 1;
      margin: 0;
      padding: 0;
      width: 100%;
    }
    iframe {
      position: relative;
      width: 100%;
      height: 100%;
    }
  }

  .Carousel_imageButtonLeft, .Carousel_imageButtonRight {
    position: absolute;
    display: block;
    top: 40%;
    width: 24px;
    height: 40px;
    background-size: 12px 20px;
    background-position: center center;
    background-repeat: no-repeat;
    z-index: 2;
    cursor: pointer;
    @media (min-width: 992px) {
      top: 45%;
      background-size: 17px 29px;
    }
    &:focus {
      outline: none;
    }
  }

  .Carousel_imageButtonLeft {
    background-image: url(/images/icon-arrow-right-white.svg);
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
    left: 15px;
  }

  .Carousel_imageButtonRight {
    background-image: url(/images/icon-arrow-right-white.svg);
    right: 15px;
  }
  .Carousel_imageEnlarge {
    position: absolute;
    display: block;
    width: 45px;
    height: 45px;
    left: 10px;
    bottom: 10px;
    cursor: pointer;
    z-index: 2;
  }
  .Carousel_imageEnlargeButton {
    background-image: url(/images/icon-enlarge.svg);
    background-position: center center;
    background-size: 46px 45px;
    background-repeat: no-repeat;
    width: 45px;
    height: 45px;
    display: block;
  }
  .Carousel_indicatorList {
    width: 100%;
    text-align: center;
    padding: 0;
    margin: 20px 0;
    & > li {
      display: inline-block;
    }
  }
  .Carousel_indicator {
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background-color: ${colors.color3};
    display: inline-block;
    margin: 0 10px;
    cursor: pointer;
    &-active {
      background-color: ${colors.color1};
    }
    &:focus {
      outline: none;
      background-color: ${colors.color1};
    }
  }
`;

class FeaturedHomesCarousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSlide: 0,
    };
    this.pause = false;
  }

  componentDidMount() {
    if (this.props.autoplay) {
      this.interval = setInterval(this.handleInterval, this.props.interval);
    }
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  handleIndicatorClick = item => event => {
    if (event.which && ![13, 32].includes(event.which)) {
      return;
    }
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.setState({
      currentSlide: item,
    });
  }

  handlePrevClick = (event = {}) => {
    if (event.preventDefault) {
      event.preventDefault();
    }
    if (event.which && ![13, 32].includes(event.which)) {
      return;
    }
    if (this.interval) {
      clearInterval(this.interval);
    }
    const { items } = this.props;
    const { currentSlide } = this.state;
    const prevIndex = (currentSlide === 0 ? (items.length - 1) : (currentSlide - 1));
    this.setState({
      currentSlide: prevIndex,
    }, this.scrollToActive);
  }

  handleNextClick = (event = {}) => {
    if (event.preventDefault) {
      event.preventDefault();
    }
    if (event.which && ![13, 32].includes(event.which)) {
      return;
    }
    if (this.interval) {
      clearInterval(this.interval);
    }
    const { items } = this.props;
    const { currentSlide } = this.state;
    const nextIndex = (currentSlide === items.length - 1 ? 0 : currentSlide + 1);
    this.setState({
      currentSlide: nextIndex,
    }, this.scrollToActive);
  }

  handleInterval = () => {
    if (!this.pause) {
      this.handleNextClick();
    }
  }

  handleMouseEnter = () => {
    this.pause = true;
  }

  handleMouseLeave = () => {
    this.pause = false;
  }

  handleTouchStart = event => {
    this.xDown = event.touches[0].clientX;
  }

  handleTouchMove = event => {
    if (!this.xDown) {
      return;
    }
    if ((this.xDown - event.touches[0].clientX) > 0) {
      this.swipeDirection = 'left';
    } else {
      this.swipeDirection = 'right';
    }
    this.xDown = null;
  }
  handleTouchEnd = () => {
    switch (this.swipeDirection) {
      case 'left':
        this.handleNextClick();
        break;
      case 'right':
        this.handlePrevClick();
        break;
      default:
        event.target.click();

    }

    this.swipeDirection = null;
  }

  scrollToActive = () => {
    if (this.thumbnailListRef) {
      const [{ offsetLeft = 0, offsetWidth: thumbWidth }] = this.thumbnailListRef.getElementsByClassName('Carousel_thumbnailItem-active');
      const containerWidth = this.thumbnailListRef.offsetWidth;
      const scrollLeft = this.thumbnailListRef.scrollLeft;

      if ((offsetLeft + thumbWidth) > (
        containerWidth + scrollLeft
      )) {
        this.thumbnailListRef.scrollLeft = offsetLeft;
      } else if (offsetLeft < scrollLeft) {
        this.thumbnailListRef.scrollLeft = (offsetLeft + thumbWidth) - containerWidth;
      }
    }
  }

  render() {
    const {
      items,
      indicators,
    } = this.props;
    const { currentSlide } = this.state;
    return (
      <div
        className={styles}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <div
          className="Carousel_image container"
          onTouchStart={this.handleTouchStart}
          onTouchMove={this.handleTouchMove}
          onTouchEnd={this.handleTouchEnd}
        >
          {items[currentSlide]}
        </div>
        {
          indicators &&
          <ul className="Carousel_indicatorList">
            {
              items.map((item, i) => (
                <li key={i.toString()}>
                  <span
                    className={`Carousel_indicator ${currentSlide === i ? 'Carousel_indicator-active' : ''}`}
                    role="button"
                    tabIndex="0"
                    onClick={this.handleIndicatorClick(i)}
                    onKeyDown={this.handleIndicatorClick(i)}
                  />
                </li>
              ))
            }
          </ul>
        }
      </div>
    );
  }
}

FeaturedHomesCarousel.propTypes = {
  autoplay: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape({
    contentUrl: PropTypes.string,
    element: PropTypes.node,
    name: PropTypes.string,
    caption: PropTypes.string,
  })).isRequired,
  interval: PropTypes.number,
  indicators: PropTypes.bool,
};

FeaturedHomesCarousel.defaultProps = {
  autoplay: true,
  interval: 6000,
  defaultImage: undefined,
  indicators: true,
};

export default FeaturedHomesCarousel;



// WEBPACK FOOTER //
// ./src/pages/IndexPage/FeaturedHomesCarousel.js